<template>
    <div>
        <div class="bg-light rounded p-50 d-flex align-items-center justify-content-between" v-on:click="show = !show">
            <div>Toplam <span class="font-weight-bolder">{{(row.Locations || []).length}}</span> Lokasyon</div>
            <feather-icon size="16" :icon="show ? 'ChevronDownIcon' : 'ChevronRightIcon'"></feather-icon>
        </div>
        <b-collapse v-model="show">
            <ul class="list-group mt-75">
                <template  v-for="(l,i) in row.Locations">
                    <li :key="l.Id + 'd'" v-if="i != 0" class="bg-light p-25 list-group-item"></li>
                    <li :key="l.Id" class="list-group-item p-50">
                        <div class="d-flex align-items-center p-25 mb-75">
                            <button class="btn btn-md btn-icon btn-flat-success" v-on:click="$emit('show-on-map',l)">
                                <span class="material-icons-outlined">map</span>
                            </button>
                            <div class="d-flex align-items-start flex-column ml-75">
                                <h6 class="p-0 text-muted mb-25">{{row.Name}}</h6>
                                <h3 class="p-0 font-wegiht-bolder mb-0">{{ l.LocationName }} | <span class="text-muted">{{ l.LocationTypeName || '-' }}</span></h3>
                            </div>
                        </div>
                        <table class="table table-sm table-bordered">
                            <tbody>
                                <tr>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Ülke</span><br/>
                                        {{l.CountryName || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Şehir/İl</span><br/>
                                        {{l.ProvinceName || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">İlçe</span><br/>
                                        {{l.DistrictName || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Mahalle</span><br/>
                                        {{l.NeighborhoodName || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Sokak</span><br/>
                                        {{l.StreetName || '-'}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Bina No</span><br/>
                                        {{l.BuildingNumber || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Kapı No</span><br/>
                                        {{l.DoorNumber || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Kat</span><br/>
                                        {{l.Floor || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Posta Kodu</span><br/>
                                        {{l.PostalCode || '-'}}
                                    </td>
                                    <td class="w-20">
                                        <span class="font-weight-bolder">Enlem / Boylam</span><br/>
                                        {{l.Xcoordinate || '-'}} / {{l.Ycoordinate || '-'}}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5">
                                        <span class="font-weight-bolder">Adres</span><br/>
                                        {{ l.Address || '-' }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5">
                                        <span class="font-weight-bolder">Posta Adresi</span><br/>
                                        {{ l.PostalAddress || '-' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                </template>
                <li class="list-group-item p-50 text-center" v-if="(row.Locations || []).length == 0">
                    Bu firmaya ait lokasyon kaydı bulunmamaktadır.
                </li>
            </ul>
        </b-collapse>
    </div>
</template>

<script>
import { BCollapse } from 'bootstrap-vue'

export default {
    components:{
        BCollapse
    },
    props:{
        row:Object,
        field:Object,
    },
    data(){
        return {
            show:false,
        }
    }
}
</script>

<style>

</style>